import { Select } from '@repletoryreach/sdk-ui/inputs';
import { useI18n } from './I18nProvider';
import { LOCALES, type Locale } from './catalog';

/**
 * Header locale picker (W39). Native sdk-ui `<Select>`: same control the
 * tenant sidebar uses: so it needs no popover/portal in the fixed header.
 * The choice persists via `I18nProvider.setLocale` (localStorage + app store).
 */
export function LocalePicker({ size = 'xs' }: { size?: 'xs' | 'sm' | 'md' }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <Select
      size={size}
      aria-label={t('shell.localePicker')}
      title={t('common.language')}
      value={locale}
      onChange={(e) => setLocale(e.currentTarget.value as Locale)}
      data={LOCALES.map((l) => ({ value: l.code, label: l.label }))}
      style={{ width: 118 }}
    />
  );
}
